module.exports = __webpack_public_path__ + "e53563fb189664ef6828304383c07792.svg";